import { Video } from "./Video";


export const AddVideoFormTemplate = Object.freeze({
    sections: [
        {
            size: 7 / 12,
            compact: true,
            inputs: [
                Video.name,
                Video.visible_timestamp,
                // Video.timestamp,
                Video.text
            ],
        },
    ]
});